import Vue from 'vue';
import {
    KGFB_AJANLAT, KGFB_AJANLATI_ADATOK, KGFB_ALAPADATOK, KGFB_DIJAK, KGFB_NYILATKOZATOK,
} from '../../../modules/Scenario';
import nyilatkozatokService from '../../../services/NyilatkozatokService';
import {
    sortAlphaAscCompareFn, sortAlphaDescCompareFn, sortEgyuttDijakFn, sortNumsAscCompareFn, sortNumsDescCompareFn,
} from '../../../utils/SortingUtils';
import kgfbService from './KgfbService';
import {
    CASCO,
    CEG, DNF,
    EVFORDULO_NYILATKOZAT,
    KGFB, MAPFREA,
    MENTES_NYILATKOZAT,
    ORDER_CASCO_PRICE_ASC,
    ORDER_CASCO_PRICE_DESC, ORDER_EGYUTT_PRICE_ASC, ORDER_EGYUTT_PRICE_DESC,
    ORDER_INSURER_NAME_ASC,
    ORDER_INSURER_NAME_DESC,
    ORDER_KGFB_PRICE_ASC,
    ORDER_KGFB_PRICE_DESC,
} from '../../../modules/Const';
import KgfbTarifa from './KgfbTarifa';
import { openDijkalkInfo } from '../../../utils/WindowUtils';
import { MINDEN_BIZTOSITO } from '../../../modules/Biztosito';
import EventBus from '../../../modules/EventBus';
import numberFormatter from '../../../utils/NumberFormatter';
import DateFormat from '../../../utils/DateFormat';
import { intToDate } from '../../../modules/Validators';
import mask from '../../../utils/mask';
import { HUNDEALER, mentorDealerFlowEnabled } from '../../../modules/Ceg';
import BrokerService from '../../../services/BrokerService';
import { HYBRID, PAPERLESS } from '../../../modules/TariffType';
import UgyfeltorzsService from '../../../services/UgyfeltorzsService';
import partnerDataByTaxNumber from '../../../services/PartnerDataByTaxNumber';
import notify from '../../../mixins/Notify';
import { getIsMotor } from '../../../modules/Gepjarmu';

const getTarifaDataForSave = (state) => {
    const tarifaData = {...state.tarifaData};

    if ((tarifaData.id == null || Number(tarifaData.id) === 0) && Number(state.id) > 0) {
        tarifaData.id = state.id;
    }
    if ((tarifaData.tarifa_id == null || Number(tarifaData.tarifa_id) === 0) && Number(state.tarifa_id) > 0) {
        tarifaData.tarifa_id = state.tarifa_id;
    }

    return tarifaData;
};

/* eslint-disable no-param-reassign */
export default {
    state: {
        token: null,
        clientEmailConfirmed: false,
        nyilatkozatId: 0,
        papirmentes: null,
        papirmentes_ugyfazon: null,
        hiddenBiztIds: [],
        szemle: false,
        loaded: false,
        casco_bonusz: null,
        calculating: false,
        announce: {},
        broker: {},
        recalculationInProgress: false,
        rendezettseg: null,
        sendDijtajekoztatoInProgress: false,
        companyDeclarations: [],
        loginCeg: 0,
        statusz: 0,
        tarifa_id: 0,
        id: 0,
        tid: 0,
        indexDij: {
            index_biztosito: null,
            index_evesdij: null,
            index_bonus: null,
        },
        hiba: {},
        loadCim: false,
        dasdij: null,
        figyelmeztetesek: [],
        kgfb: {
            valasztottBiztosito: null,
        },
        valasztottKgfbBiztosito: null,
        valasztottCascoBiztosito: null,
        valasztottAssistanceBiztosito: null,
        valasztottKgfbBiztositoCalcId: null,
        valasztottCascoBiztositoCalcId: null,
        kgfb_calculation_id: null,
        casco_calculation_id: null,
        egyuttkotottBiztosito: null,
        kgfbBiztUjraszamolando: [],
        cascoBiztUjraszamolando: [],
        valasztottAssistanceDijAdatok: null,
        fedezetlensegiDij: null,
        kgfbNyilatkozatok: {
            kotelezo: null,
            nem_kotelezo: null,
        },
        nyilatkozatok: null,
        casco: {},
        tarifaData: {
            papirmentes: null,
            papirmentes_ugyfazon: null,
            statusz: 50,
            ajanl_vehicle_use: 1,
            das: {},
            futar: false,
            eugyintezes: true,
            allianzemail: true,
            allianztelefon: true,
            van_24_evnel_fiatalabb_gyermeke: false,
            serulesek_esemenyek: {},
            groupama: {},
            elozo_karok: {},
            allapotlap: {},
            uniqa: {},
            max_oldal: 0,
            biztositast_felmondta: false,
            forgalmi_cim: {},
            evenkenti_karok: {},
            karok: {
                alfa_karokozas: null,
                allianz_karokozas: null,
                generali_karokozas: null,
                genertel_karokozas: null,
                granit_karokozas: null,
                groupama_karokozas: null,
                kobe_karokozas: null,
                kobe_veszelykozossegi: null,
                ominimo_karokozas: null,
                posta_karokozas: null,
                signal_karokozas: null,
                signal_ominimo_karokozas: null,
                tf_kar_ebben_bonuszkifizet_db: null,
                tf_kar_ebben_utoljara_ev: null,
                union_karokozas: null,
                uniqa_karokozas: null,
                tf_utolso_bizt_idoszakban_okozott_karkifizetessel_jaro_karok_szama: null,
            },
            jelenlegi_serulesek_db: null,
            kgfb_eloszerzodes_datuma: null,
            casco_eloszerzodes_datuma: null,
            forgcim_megegyezik: true,
            ajanl_fizmod_type: 1,
            ajanl_fizutem_type: 1,
            casco_fizutem: 1,
            casco_fizmod: 1,
            gfb_elozo_szerzodesek_szama: {
                tf_kgfb_eloszerz_3: 0,
                tf_kgfb_eloszerz_1: 0,
                tf_kgfb_eloszerz_2: 0,
                tf_kgfb_eloszerz_13: 0,
                tf_kgfb_eloszerz_8: 0,
                tf_kgfb_eloszerz_4: 0,
                tf_kgfb_eloszerz_16: 0,
            },
            ajanl_kock_kezd: null,
            szemlet_vegzo: {},
        },
        informationData: {},
        modozatok: [],
        ovb_kotheto_modozatok: [],
        kedvezmenyek: {},
        cascoproducts: {},
        cascokedvezmenyek: {},
        additions: {},
        cascoadditions: {},
        szerzodo: {
            nev: '',
            nem: 0,
        },
        tarifalasSzerzodoMegbizasEmailAdatok: null,
        uzembentarto: {
            forgcim_megegyezik: true,
            titulus: 0,
            allampolgarsag: 1,
            address: {
                zip: '',
                city_code: '',
            },
            mobil: '',
            forgalmi_address: {},
            mail_address: {},
        },
        tulajdonos: {
            address: {},
            forgalmi_address: {},
        },
        finanszirozo: {
            address: {},
            mail_address: {},
        },
        ugyfel: {},
        gepjarmu: {
            jobbkormanyos: false,
            securities: {},
            kulcsok: {},
            extrak: {},
            nincsrendszam: false,
        },
        dijak: [],
        assistance: [],
        errors: [],
        selected: {},
        nyilatkozatPdf: null,
        offerDeclarations: {},
        ovbUzletkoto: null,
        ovbTanacsado: null,
        ovbKezdesNyilatkozatok: [],
        ovbCallbackHash: null,
        esemeny_esemenyek: [],
    },

    getters: {
        getId: (state) => state.id,
        van24EvnelFiatalabbGyermeke: (state) => state.tarifaData.van_24_evnel_fiatalabb_gyermeke,
        selected: (state) => state.selected,
        getRecalculationInProgress: (state) => state.recalculationInProgress,
        getRendezettseg: (state) => state.rendezettseg,
        getSendDijtajekoztatoInProgress: (state) => state.sendDijtajekoztatoInProgress,
        isClientEmailConfirmed: (state) => state.clientEmailConfirmed,
        isHibrid(state) {
            return ['Y', true].includes(state.tarifaData.hibrid_kotes) || state.tarifaData.tipus === HYBRID;
        },
        kellSzemle: (state) => state.szemle,
        getCompanyDeclarations: (state) => (state.companyDeclarations ? state.companyDeclarations : []),
        token: (state) => state.token,
        nyilatkozatId: (state) => state.nyilatkozatId,
        casco_bonusz(state) {
            return state.casco_bonusz?.length > 0 ? state.casco_bonusz : '';
        },
        releaseEurotaxUjkoriErtekLock(state) {
            return state.release_eurotax_ujkori_ertek_lock;
        },
        hiddenBiztIds: (state) => state.hiddenBiztIds,
        kockakezdetJovobeli(state) {
            const today = new Date(new Date().setHours(0, 0, 0, 0));
            let kockakezdet = null;
            if (state.tarifaData.ajanl_kock_kezd) {
                kockakezdet = intToDate(state.tarifaData.ajanl_kock_kezd);
            }
            return kockakezdet >= today;
        },
        companyId(state) {
            return +state.tarifaData.ceg || +state.broker.ceg || undefined;
        },
        isOvb(state) {
            return [462,518].includes(+state.tarifaData.ceg || +state.broker.ceg);
        },
        isDealerProcess(state) {
            const companyId = +state.tarifaData.ceg || +state.broker.ceg;
            return [HUNDEALER, 6].includes(companyId) || mentorDealerFlowEnabled(companyId);
        },
        showNewDesign() {
            return true;
        },
        getBroker(state) {
            return state.broker;
        },
        dasdij(state) {
            return state.dasdij;
        },
        ovbKothetoModozatok(state) {
            return state.ovb_kotheto_modozatok;
        },
        visszaigazoloKodKgfb(state) {
            return state.visszaigazoloKodKgfb;
        },
        visszaigazoloKodCasco(state) {
            return state.visszaigazoloKodCasco;
        },
        visszaigazoloKodAssistance(state) {
            return state.visszaigazoloKodAssistance;
        },
        getAssistance(state) {
            return state.assistance;
        },
        getErrors(state) {
            return state.errors;
        },
        getCalculatedBiztDB(state) {
            return state.dijak.length;
        },
        getCalculatedKGFBDijDb: (state) => state.dijak
            .filter((dij) => !!dij.kgfb && Number(dij.kgfb.yearly_fee) > 0).length,
        getCalculatedCASCODijDB: (state) => state.dijak
            .filter((dij) => !!dij.casco && Number(dij.casco.yearly_fee) > 0).length,
        getCalculatedCsomagDB(state) {
            return state.dijak.filter((dij) => Number(dij.kgfb.yearly_fee) > 0).length;
        },
        evenkenti_karok(state) {
            return state.tarifaData.evenkenti_karok;
        },
        nyilatkozatok: (state) => state.nyilatkozatok,
        kgfbNyilatkozatok: (state) => state.kgfbNyilatkozatok,
        fedezetlensegiDij: (state) => state.fedezetlensegiDij,
        vanFedezetlensegiDij: (state) => state.fedezetlensegiDij !== null && state.fedezetlensegiDij > 0,
        valasztottKgfbBiztosito: (state) => state.valasztottKgfbBiztosito,
        valasztottKgfbBiztositoCalcId: (state) => state.valasztottKgfbBiztositoCalcId,
        valasztottCascoBiztosito: (state) => state.valasztottCascoBiztosito,
        valasztottCascoBiztositoCalcId: (state) => state.valasztottCascoBiztositoCalcId,
        valasztottAssistanceBiztositoId: (state) => state.valasztottAssistanceBiztosito,
        kgfb_calculation_id: (state) => state.kgfb_calculation_id,
        casco_calculation_id: (state) => state.casco_calculation_id,
        egyuttkotottBiztosito: (state) => state.egyuttkotottBiztosito,
        valasztottAssistanceDijAdatok: (state) => state.valasztottAssistanceDijAdatok,
        valasztottAssistanceBiztosito: (state) => state.valasztottAssistanceDijAdatok?.biztositoId,
        valasztottAssistanceCsomag: (state) => (state.valasztottAssistanceDijAdatok ? {
            biztositoid: state.valasztottAssistanceDijAdatok.biztositoId,
            csomagid: state.valasztottAssistanceDijAdatok.csomagid
        } : null),
        azonosKockkezd: (state) => state.tarifaData.ajanl_kock_kezd === state.tarifaData.kock_kezd_casco,
        kgfbBiztUjraszamolando: (state) => state.kgfbBiztUjraszamolando,
        cascoBiztUjraszamolando: (state) => state.cascoBiztUjraszamolando,
        kedvezmenyekbiztosito: (state) => state.kedvezmenyekbiztosito,
        kedvezmenyekalaptabla: (state) => state.kedvezmenyekalaptabla,
        cascoproducts: (state) => state.cascoproducts,
        cascokedvezmenyek: (state) => state.cascokedvezmenyek,
        additions: (state) => state.additions,
        cascoadditions: (state) => state.cascoadditions,
        valasztottDijAdatok: (state) => state.dijak
            .filter((dij) => dij.biztositoid === state.valasztottKgfbBiztosito)[0],
        valasztottCascoDijAdatok: (state) => state.dijak
            .filter((dij) => dij.biztositoid === state.valasztottCascoBiztosito)[0],
        dijak: (state) => (Array.isArray(state.dijak) ? state.dijak : []),
        dijakKGFB: (state) => state.dijak.filter(
            (dij) => dij.kgfb
                && dij.kgfb.yearly_fee
                && dij.kgfb.yearly_fee > 0,
        ),
        dijakCASCO: (state) => {
            state.dijak.filter(
                (dij) => dij.casco
                    && dij.casco.yearly_fee
                    && dij.casco.yearly_fee > 0,
            );
        },
        kgfb: (state) => state.kgfb,
        indexDij: (state) => state.indexDij,
        casco: (state) => state.casco,
        szerzodo: (state) => state.szerzodo,
        tarifalasSzerzodoUgyfazon: (state) => state.tarifalasSzerzodoMegbizasEmailAdatok?.ugyfazon,
        tarifalasSzerzodoEmail: (state) => state.tarifalasSzerzodoMegbizasEmailAdatok?.email,
        tarifalasSzerzodoEmailMegerositve: (state) => !!state.tarifalasSzerzodoMegbizasEmailAdatok?.emailMegerositesDatum,
        tarifalasSzerzodoMegbizasFeltoltve: (state) => !!state.tarifalasSzerzodoMegbizasEmailAdatok?.megbizasiFeltoltve,
        tarifalasSzerzodoMegbizasElfogadva: (state) => !!state.tarifalasSzerzodoMegbizasEmailAdatok?.megbizasiFeltoltve
            && !state.tarifalasSzerzodoMegbizasEmailAdatok?.megbizasiFrissebbElerheto,
        uzembentarto: (state) => state.uzembentarto,
        tulajdonos: (state) => state.tulajdonos,
        finanszirozo: (state) => state.finanszirozo,
        ugyfel: (state) => state.ugyfel,
        gepjarmu: (state) => state.gepjarmu,
        isCalculating: (state) => state.calculating,
        loadCim: (state) => state.loadCim,
        tarifaData: (state) => state.tarifaData,
        informationData: (state) => state.informationData,
        id: (state) => state.id,
        tid: (state) => state.tid,
        tarifaId: (state) => state.tarifa_id,
        tarifaIdForCopy: (state) => state.tarifaData.tarifa_id,
        // TODO: identify the one needed id/tid and remove the others if those are not necessary.
        statusz: (state) => state.statusz,
        isBnet: (state) => parseInt(state.loginCeg, 10) === 1,
        hiba: (state) => state.hiba,
        figyelmeztetesek: (state) => state.figyelmeztetesek,
        vanFigyelmeztetes: (state) => state.figyelmeztetesek.length > 0,
        modozatok: (state) => state.modozatok,
        modozat: (state) => state.modozatok,
        announce: (state) => state.announce,
        isPapirmentes(state) {
            return state.tarifaData.papirmentes || state.tarifaData.tipus === PAPERLESS;
        },
        papirmentesUgyfazon: (state) => state.tarifaData.papirmentes_ugyfazon,
        informantSent: (state) => state.tarifaData.informantSent,
        szemletVegzo: (state) => state.tarifaData.szemlet_vegzo,
        getOkozottEKart: (state) => state.tarifaData.karok.tf_kar_ebben_utoljara_ev,
        megbizasi: (state) => state.megbizasi,
        nyilatkozatPdf: (state) => state.nyilatkozatPdf,
        offerDeclarations: (state) => state.offerDeclarations,
        getBKatJogsi: (state) => (state.tarifaData.b_kat_licence_date
            ? Number(state.tarifaData.b_kat_licence_date.toString().substring(0,4))
            : null),
        getElsoJogsi: (state) => (state.uzembentarto.licence_date
            ? Number(state.uzembentarto.licence_date.toString().substring(0,4))
            : null),
        hideKgfbFee: (state) => state.tarifaData.ajanl_megkotok_type === DNF && state.dijak.length === 1,
        getOvbUzletkoto: (state) => state.ovbUzletkoto,
        getOvbTanacsado: (state) => state.ovbTanacsado,
        getOvbKezdesNyilatkozatok: (state) => state.ovbKezdesNyilatkozatok,
        getOvbCallbackHash: (state) => state.ovbCallbackHash,
        isMotorCasco: (state) => state.modozatok?.includes(CASCO) && getIsMotor(+state.gepjarmu?.fajta),
        isMotor: (state) => getIsMotor(+state.gepjarmu?.fajta),
        vanCascoBonusz: (state) => state.tarifaData.ajanl_uzem_casco_bonus != null
            && state.tarifaData.ajanl_uzem_casco_bonus !== ''
            && state.tarifaData.ajanl_uzem_casco_bonus > -1,
        esemeny_esemenyek: (state) => state.esemeny_esemenyek,
    },
    mutations: {
        setFolyamat: (state, value) => {
            state.tarifaData.tipus = value;
            state.tarifaData.papirmentes = value === PAPERLESS;
            state.tarifaData.hibrid_kotes = value === HYBRID;
        },
        setVan24EvnelFiatalabbGyermeke: (state, value) => {
            state.tarifaData.van_24_evnel_fiatalabb_gyermeke = value;
        },
        setSelected: (
            state,
            value
        ) => {
            state.selected = value;
        },
        setEgyuttkotottBiztosito: (
            state,
            value,
        ) => {
            state.egyuttkotottBiztosito = value;
        },
        addKgfbBiztUjraszamolando: (
            state,
            value,
        ) => {
            if (!state.kgfbBiztUjraszamolando.includes(value)) state.kgfbBiztUjraszamolando.push(value);
        },
        removeKgfbBiztUjraszamolando: (
            state,
            value,
        ) => {
            state.kgfbBiztUjraszamolando = state.kgfbBiztUjraszamolando.filter((biztid) => biztid !== value);
        },
        resetKgfbBiztUjraszamolando: (
            state,
        ) => {
            state.kgfbBiztUjraszamolando = [];
        },
        addCascoBiztUjraszamolando: (
            state,
            value,
        ) => {
            if (!state.cascoBiztUjraszamolando.includes(value)) state.cascoBiztUjraszamolando.push(value);
        },
        removeCascoBiztUjraszamolando: (
            state,
            value,
        ) => {
            state.cascoBiztUjraszamolando = state.cascoBiztUjraszamolando.filter((biztid) => biztid !== value);
        },
        resetCascoBiztUjraszamolando: (
            state
        ) => {
            state.cascoBiztUjraszamolando = [];
        },
        setRecalculationInProgress: (
            state,
            value,
        ) => {
            state.recalculationInProgress = value;
        },
        setRendezettseg: (
            state,
            value,
        ) => {
            state.rendezettseg = value;
        },
        setSendDijtajekoztatoInProgress: (
            state,
            value,
        ) => {
            state.sendDijtajekoztatoInProgress = value;
        },
        setPartnerDataByTaxNr(state, { partnerData, telephelyIdx, partnerType }) {
            state.uzembentarto.address.zip = partnerData.hq.zip;
            state.uzembentarto.address.city_code = partnerData.hq.city_code;
            if (parseInt(telephelyIdx, 10) >= 0) {
                state.tarifaData.forgalmi_cim.zip = partnerData.addresses[telephelyIdx].zip;
                state.tarifaData.forgalmi_cim.city_code = partnerData.addresses[telephelyIdx].city_code;
            }
            if (partnerType === CEG) {
                state.uzembentarto.cegnev = partnerData.name;
                state.uzembentarto.cegforma = partnerData.company_type;
            } else {
                state.uzembentarto.name = partnerData.name;
            }
            state.uzembentarto.teaor = partnerData.teaor;
            state.uzembentarto.additional = {
                taxnumber: partnerType === CEG
                    ? partnerData.taxnumber
                    : partnerData.adoszam,
                address: partnerData.hq,
                forgalmi_address: parseInt(telephelyIdx, 10) >= 0
                    ? partnerData.addresses[telephelyIdx]
                    : null,
            };
        },
        setTulajDataByTaxNr(state, { partnerData }) {
            state.tulajdonos.address.zip = partnerData.hq.zip;
            state.tulajdonos.address.city_code = partnerData.hq.city_code;
            state.tulajdonos.address.building = partnerData.hq.building;
            state.tulajdonos.address.door = partnerData.hq.door;
            state.tulajdonos.address.floor = partnerData.hq.floor;
            state.tulajdonos.address.house_nr_from = partnerData.hq.house_nr_from;
            state.tulajdonos.address.house_nr_to = partnerData.hq.house_nr_to;
            state.tulajdonos.address.street_id = partnerData.hq.street_id;
            state.tulajdonos.address.street_type = partnerData.hq.street_type;
            state.tulajdonos.cegnev = partnerData.name;
            state.tulajdonos.cegforma = partnerData.company_type;
            state.tulajdonos.teaor = partnerData.teaor;
            state.tulajdonos.additional = {
                taxnumber: partnerData.adoszam,
                address: partnerData.hq,
            };
        },
        setClientEmailConfirmed(state, value) {
            state.clientEmailConfirmed = value;
        },
        setHibrid(state, hibridKotes) {
            state.tarifaData.hibrid_kotes = !!hibridKotes;
        },
        setSzemle(state, szemle) {
            state.szemle = !!szemle;
        },
        hideBiztosito(state, biztositoId) {
            if (state.hiddenBiztIds.includes(biztositoId)) {
                state.hiddenBiztIds.splice(state.hiddenBiztIds.indexOf(biztositoId), 1);
            } else {
                state.hiddenBiztIds.push(biztositoId);
            }
        },
        setModozatok(state, payload) {
            state.tarifaData.modozatok = payload;
            state.modozatok = payload;
        },
        setToken(state, token) {
            state.token = token;
        },
        setNyilatkozatId(state, nyilatkozatId) {
            state.nyilatkozatId = nyilatkozatId;
        },
        setBroker(state, broker) {
            state.broker = broker;
        },
        setCompanyDeclarations(state, declarations) {
            state.companyDeclarations = declarations;
        },
        setPapirmentes(state, payload) {
            state.tarifaData.papirmentes = payload;
        },
        formatNumbers(state) {
            if (state.tarifaData.ujkori_ertek) {
                state.tarifaData.ujkori_ertek = numberFormatter.removeThousandSeparators(state.tarifaData.ujkori_ertek);
            }
            if (state.tarifaData.aegon_extrak_osszertek) {
                state.tarifaData.aegon_extrak_osszertek = numberFormatter.removeThousandSeparators(
                    state.tarifaData.aegon_extrak_osszertek,
                );
            }
            if (state.gepjarmu.kmallas) {
                state.gepjarmu.kmallas = numberFormatter.removeThousandSeparators(state.gepjarmu.kmallas);
            }
            if (!!state.tarifaData.finanszirozas && !!state.tarifaData.finanszirozas.finanszirozo_hitelosszeg) {
                state.tarifaData.finanszirozas.finanszirozo_hitelosszeg = numberFormatter.removeThousandSeparators(
                    state.tarifaData.finanszirozas.finanszirozo_hitelosszeg,
                );
            }
            if (state.tarifaData.elozoszerz_eves_dij) {
                state.tarifaData.elozoszerz_eves_dij = numberFormatter.removeThousandSeparators(
                    state.tarifaData.elozoszerz_eves_dij,
                );
            }
        },

        setKgfbAdditions(state, payload) {
            state.additions = payload;
        },

        setCascoAdditions(state, payload) {
            state.cascoadditions = payload;
        },

        setCascoProducts(state, payload) {
            state.cascoproducts = payload;
        },

        setKgfbKedvezmenyek(state, payload) {
            state.kedvezmenyekbiztosito = payload;
        },

        setCascoKedvezmenyek(state, payload) {
            state.cascokedvezmenyek = payload;
        },
        setFedezetlensegiDij(state, fedezetlensegiDij) {
            state.fedezetlensegiDij = fedezetlensegiDij;
        },
        resetBerendezesek(state) {
            state.gepjarmu.securities = {};
        },
        setErrors(state, errors) {
            state.errors = errors;
        },
        resetUzemeltetettGepjDb(state) {
            state.tarifaData.gfb_elozo_szerzodesek_szama = {};
        },
        resetGepjDb(state) {
            state.tarifaData.gfb_elozo_szerzodesek_szama = {};
            state.tarifaData.gfb_elozo_szerzodesek_szama.tf_kgfb_eloszerz_1 = 0;
            state.tarifaData.gfb_elozo_szerzodesek_szama.tf_kgfb_eloszerz_2 = 0;
            state.tarifaData.gfb_elozo_szerzodesek_szama.tf_kgfb_eloszerz_3 = 0;
            state.tarifaData.gfb_elozo_szerzodesek_szama.tf_kgfb_eloszerz_4 = 0;
            state.tarifaData.gfb_elozo_szerzodesek_szama.tf_kgfb_eloszerz_8 = 0;
            state.tarifaData.gfb_elozo_szerzodesek_szama.tf_kgfb_eloszerz_13 = 0;
            state.tarifaData.gfb_elozo_szerzodesek_szama.tf_kgfb_eloszerz_16 = 0;
        },
        resetGroupama(state) {
            state.tarifaData.groupama = {};
        },
        resetUniqa(state) {
            state.tarifaData.uniqa = {};
        },
        resetElozoKarok(state) {
            state.tarifaData.elozo_karok = {};
        },
        resetAllapotLap(state) {
            state.tarifaData.allapotlap = {
                tf_allap_SzakertoiSzemle: true,
            };
        },
        resetEvenkentiKarok(state) {
            state.tarifaData.evenkenti_karok = {};
        },
        resetKarok(state) {
            state.tarifaData.karok = {};
        },
        resetSzemletVegzo(state) {
            state.tarifaData.szemlet_vegzo = {};
        },
        resetHasznalatiModok(state) {
            state.tarifaData.veszelyes_hasznalati_modok = {};
        },
        setCalculating: (state, payload) => {
            state.calculating = payload;
        },
        setLoadCim: (state, payload) => {
            state.loadCim = payload;
        },
        setAnnouncement: (state, announce) => {
            state.announce = announce;
        },
        init: (state, payload) => {
            state.id = payload.id;
            state.tid = payload.tid;
            state.token = payload.token;
        },
        setHiba: (state, hiba) => {
            state.hiba = hiba;
        },
        loaded: (state) => {
            state.loaded = true;
        },
        setLoginCeg: (state, loginCeg) => {
            state.loginCeg = loginCeg;
        },
        setFigyelmeztetesek: (state, figyelmeztetesek) => {
            state.figyelmeztetesek = figyelmeztetesek;
        },
        setTarifaId: (state, tarifaid) => {
            state.tarifa_id = tarifaid;
        },
        setId: (state, id) => {
            state.id = id;
        },
        setStatusz(state, statusz) {
            state.statusz = statusz;
            state.tarifaData.statusz = statusz;
        },
        setProp(state, payload) {
            Vue.prototype.$setNestedPropVal(state, payload.path.split('.'), payload.value);
        },
        deleteProp(state, propName) {
            Vue.prototype.$deleteNestedProp(state, propName.split('.'));
        },
        setDij(state, payload) {
            Vue.set(state.dijak, payload.index, payload.dijObj);
        },
        setModozat(state, modozat) {
            state.modozatok = modozat;
        },
        setNyilatkozadPdf(state, nyilatkozatPdf) {
            state.nyilatkozatPdf = nyilatkozatPdf;
        },
        setOfferDeclaration(state, {type, key, value}) {
            if (state.offerDeclarations) {
                if (type) state.offerDeclarations[type][key] = value;
                else state.offerDeclarations[key] = value;
            }
        },
        setOfferDeclarations(state, declarations) {
            state.offerDeclarations = declarations;
        },
        setBKatJogsi(state, bKatJogsi) {
            state.tarifaData.b_kat_licence_date = bKatJogsi;
            state.tarifaData.b_kat_licence_date = `${+state.tarifaData.b_kat_licence_date}0101`;
        },
        setElsoJogsi(state, elsoJogsi) {
            state.uzembentarto.licence_date = elsoJogsi;
            state.uzembentarto.licence_date = `${+state.uzembentarto.licence_date}0101`;
        },
        setOvbUzletkoto(state, ovbUzletkoto) {
            state.ovbUzletkoto = ovbUzletkoto || {};
        },
        setOvbTanacsado(state, ovbTanacsado) {
            state.ovbTanacsado = ovbTanacsado || {};
        },
        setOvbKezdesNyilatkozatok(state, ovbKezdesNyilatkozatok) {
            state.ovbKezdesNyilatkozatok = ovbKezdesNyilatkozatok || [];
        },
        setOvbCallbackHash(state, ovbCallbackHash) {
            state.ovbCallbackHash = ovbCallbackHash;
        },
    },
    actions: {
        setAvailablePages(context, { oldal }) {
            const available = context.state.statusz > 200 || context.state.tarifaData.statusz > 200;
            context.commit('updateAvailablePages', [
                (oldal < 5) || available,
                (oldal < 5 && oldal > 0) || available,
                (oldal < 5 && oldal > 1) || available,
                (oldal < 5 && oldal > 2) || available,
                (oldal > 3) || available,
            ]);
        },
        setKedvezmenyekAdditions(context, kedvezmenyek) {
            context.commit('setProp', {
                path: 'kedvezmenyekbiztosito',
                value: { ...context.state.kedvezmenyekbiztosito, ...kedvezmenyek.kgfb.discounts.biztosito },
            });
            context.commit('setProp', {
                path: 'kedvezmenyekalaptabla',
                value: { ...context.state.kedvezmenyekalaptabla, ...kedvezmenyek.kgfb.discounts.alaptabla },
            });
            context.commit('setProp', {
                path: 'additions',
                value: { ...context.state.additions, ...kedvezmenyek.kgfb.additions },
            });
            context.commit('setProp', {
                path: 'cascokedvezmenyek',
                value: { ...context.state.cascokedvezmenyek, ...kedvezmenyek.casco.discounts },
            });
            context.commit('setProp', {
                path: 'cascoadditions',
                value: { ...context.state.cascoadditions, ...kedvezmenyek.casco.additions },
            });
            context.commit('setProp', {
                path: 'cascoproducts',
                value: { ...context.state.cascoproducts, ...kedvezmenyek.casco.products },
            });
        },
        getDijkalkXML: (context, { biztositoId, modozat }) => {
            kgfbService.getDijalkXML(context.state.id, biztositoId, modozat)
                .then((response) => {
                    openDijkalkInfo(response.data);
                });
        },
        saveFutureClientData: (context, modozat) => {
            kgfbService.saveFutureClientData({
                email: context.state.uzembentarto.email,
                mobil: context.state.uzembentarto.mobil,
                evfordulo: modozat === KGFB
                    ? context.state.tarifaData.elozoszerz_evfordulo_datum
                    : context.state.tarifaData.casco_evfordulo_datuma,
                modozat,
                nyilatkozat_id: context.state.companyDeclarations
                    .filter((decl) => decl.place === EVFORDULO_NYILATKOZAT)[0]?.id,
            });
        },
        orderDijakPriceAsc: (context) => {
            context.commit('setProp', {
                path: 'dijak',
                value: context.state.dijak.sort((a, b) => sortNumsAscCompareFn(a.kgfb.yearly_fee, b.kgfb.yearly_fee)),
            });
        },
        orderCheapestsFirst: (context) => {
            const dijak = context.state.dijak.sort(
                (a, b) => sortNumsAscCompareFn(
                    a.kgfb.yearly_fee,
                    b.kgfb.yearly_fee,
                ),
            );

            let gfbIndex = 0;
            let cascoIndex = 0;
            let cheapestGfb = dijak[gfbIndex].kgfb.yearly_fee;
            let cheapestCasco = dijak[cascoIndex].casco.yearly_fee;

            for (let i = 0; i < dijak.length; i += 1) {
                if (!dijak[gfbIndex].kgfb.yearly_fee) dijak[gfbIndex].kgfb.yearly_fee = 0;

                if ((Number(dijak[i].kgfb.yearly_fee) < Number(cheapestGfb))
                    && (Number(dijak[i].kgfb.yearly_fee) > 0)
                ) {
                    cheapestGfb = dijak[i].kgfb.yearly_fee;
                    gfbIndex = i;
                }
                if (!dijak[cascoIndex].casco.yearly_fee) dijak[cascoIndex].casco.yearly_fee = 0;

                if ((Number(dijak[i].casco.yearly_fee) < Number(cheapestCasco))
                    && (Number(dijak[i].casco.yearly_fee) > 0)) {
                    cheapestCasco = dijak[i].casco.yearly_fee;
                    cascoIndex = i;
                }
            }
            let tmp = dijak[0];
            dijak[0] = dijak[gfbIndex];
            dijak[gfbIndex] = tmp;

            if (cascoIndex !== gfbIndex) {
                // eslint-disable-next-line prefer-destructuring
                tmp = dijak[1];
                dijak[1] = dijak[cascoIndex];
                dijak[cascoIndex] = tmp;
            }
            /* eslint-enable prefer-destructuring */

            context.commit('setProp', {
                path: 'dijak',
                value: dijak,
            });
        },
        orderDijakPriceDesc: (context) => {
            context.commit('setProp', {
                path: 'dijak',
                value: context.state.dijak.sort(
                    (a, b) => sortNumsDescCompareFn(
                        a.kgfb.yearly_fee,
                        b.kgfb.yearly_fee,
                    ),
                ),
            });
        },
        orderCascoDijakPriceAsc: (context) => {
            context.commit('setProp', {
                path: 'dijak',
                value: context.state.dijak.sort(
                    (a, b) => sortNumsAscCompareFn(a.casco.yearly_fee, b.casco.yearly_fee),
                ),
            });
        },
        orderCascoDijakPriceDesc: (context) => {
            context.commit('setProp', {
                path: 'dijak',
                value: context.state.dijak.sort(
                    (a, b) => sortNumsDescCompareFn(a.casco.yearly_fee, b.casco.yearly_fee),
                ),
            });
        },
        orderEgyuttDijakPriceAsc: (context) => {
            context.commit('setProp', {
                path: 'dijak',
                value: context.state.dijak.sort(sortEgyuttDijakFn('asc')),
            });
        },
        orderEgyuttDijakPriceDesc: (context) => {
            context.commit('setProp', {
                path: 'dijak',
                value: context.state.dijak.sort(sortEgyuttDijakFn('desc')),
            });
        },
        orderDijakBiztNeveAsc: (context) => {
            const modozatPropName = context.state.modozatok.includes(KGFB) ? 'kgfb' : 'casco';
            context.commit('setProp', {
                path: 'dijak',
                value: context.state.dijak.sort(
                    (a, b) => sortAlphaAscCompareFn(
                        a[modozatPropName]?.insurance_company_props?.name,
                        b[modozatPropName]?.insurance_company_props?.name,
                    ),
                ),
            });
        },
        orderDijakBiztNeveDesc: (context) => {
            const modozatPropName = context.state.modozatok.includes(KGFB) ? 'kgfb' : 'casco';
            context.commit('setProp', {
                path: 'dijak',
                value: context.state.dijak.sort(
                    (a, b) => sortAlphaDescCompareFn(
                        a[modozatPropName]?.insurance_company_props?.name,
                        b[modozatPropName]?.insurance_company_props?.name,
                    ),
                ),
            });
        },
        orderFees(context) {
            const feeOrderStoreFnNameMap = {
                [ORDER_INSURER_NAME_ASC]: 'orderDijakBiztNeveAsc',
                [ORDER_INSURER_NAME_DESC]: 'orderDijakBiztNeveDesc',
                [ORDER_KGFB_PRICE_ASC]: 'orderDijakPriceAsc',
                [ORDER_KGFB_PRICE_DESC]: 'orderDijakPriceDesc',
                [ORDER_CASCO_PRICE_ASC]: 'orderCascoDijakPriceAsc',
                [ORDER_CASCO_PRICE_DESC]: 'orderCascoDijakPriceDesc',
                [ORDER_EGYUTT_PRICE_ASC]: 'orderEgyuttDijakPriceAsc',
                [ORDER_EGYUTT_PRICE_DESC]: 'orderEgyuttDijakPriceDesc',
            };
            context.dispatch(feeOrderStoreFnNameMap[+context.state.rendezettseg]);
        },
        saveRendezettseg(context) {
            context.commit('startLoading');
            return kgfbService.saveRendezettseg(context.state.id, context.state.rendezettseg)
                .then(async (response) => {
                    if (response.status === 200) {
                        await new Promise((r) => setTimeout(r, 1000));
                        context.commit('stopLoading');
                    }
                });
        },
        offer(context) {
            return kgfbService.offer(context.state.tarifaData.id, context.state.tarifaData.tarifa_id);
        },
        recalcAll(context) {
            context.commit('startLoading');
            context.dispatch('removeKgfbSelection');
            context.dispatch('removeCascoSelection');
            return kgfbService.calculate(
                context.state.tid,
                context.state.id,
                {
                    ...KgfbTarifa.getRecalculateDataByBiztIds(
                        MINDEN_BIZTOSITO,
                        true,
                        context.state.modozatok,
                        false, context,
                    ),
                },
            )
                .then((response) => {
                    KgfbTarifa.calculationResponseHandler(response, context);
                    if (response.data.dijak.kgfb) {
                        context.commit('setProp', {
                            path: 'valasztottKgfbBiztositoCalcId',
                            value: response.data.dijak.kgfb.selected,
                        });
                        context.commit('setProp', {
                            path: 'hiddenBiztIds',
                            value: response.data.dijak.kgfb.gfb_eltuntet,
                        });
                    }

                    context.commit('setProp', {
                        path: 'casco_bonusz',
                        value: response.data.dijak?.casco?.casco_bonusz,
                    });

                    if (response.data.dijak.casco) {
                        context.commit('setProp', {
                            path: 'valasztottCascoBiztositoCalcId',
                            value: response.data.dijak.casco.selected,
                        });
                        context.commit('setProp', {
                            path: 'hiddenBiztIds',
                            value: Array.from(
                                new Set(
                                    [
                                        ...context.state.hiddenBiztIds,
                                        ...response.data.dijak.casco.casco_eltuntet,
                                    ],
                                ),
                            ),
                        });
                    }

                    if (!response.data.dijak?.kgfb?.selected) {
                        context.commit('setProp', {
                            path: 'valasztottKgfbBiztositoCalcId',
                            value: null,
                        });
                        context.commit('setProp', {
                            path: 'valasztottKgfbBiztosito',
                            value: null,
                        });
                        context.commit('setProp', {
                            path: 'kgfb_calculation_id',
                            value: null,
                        });
                    }

                    if (!response.data.dijak?.casco?.selected) {
                        context.commit('setProp', {
                            path: 'valasztottCascoBiztositoCalcId',
                            value: null,
                        });
                        context.commit('setProp', {
                            path: 'casco_calculation_id',
                            value: null,
                        });
                        context.commit('setProp', {
                            path: 'valasztottCascoBiztosito',
                            value: null,
                        });
                    }

                    context.dispatch('orderFees');
                });
        },
        egyuttkotesUjraszamol(context) {
            context.commit('startLoading');
            const ujraszamolandoBiztositok = [];
            ujraszamolandoBiztositok.push(context.state.valasztottKgfbBiztosito);
            if (
                parseInt(context.state.valasztottKgfbBiztosito, 10)
                !== parseInt(context.state.valasztottCascoBiztosito, 10)
            ) {
                ujraszamolandoBiztositok.push(context.state.valasztottCascoBiztosito);
            }
            return kgfbService.calculate(
                context.state.tid,
                context.state.id,
                {
                    ...KgfbTarifa.getRecalculateDataByBiztIds(
                        ujraszamolandoBiztositok,
                        false,
                        [KGFB, CASCO],
                        true,
                        context,
                    ),
                    calculation_id: context.state.kgfb_calculation_id,
                    casco_calculation_id: context.state.casco_calculation_id,
                    biztosito_id: context.state.valasztottKgfbBiztosito,
                    casco_biztosito_id: context.state.valasztottCascoBiztosito,
                    assistance: context.getters.valasztottAssistanceCsomag
                        ? context.getters.valasztottAssistanceCsomag
                        : null,
                },
            )
                .then((response) => {
                    KgfbTarifa.calculationResponseHandler(response, context);
                    EventBus.$emit('dij-calculated', {
                        recalculatedKgfbBiztIds: ujraszamolandoBiztositok,
                        recalculatedCascoBiztIds: ujraszamolandoBiztositok,
                    });

                    context.commit('setProp', {
                        path: 'casco_bonusz',
                        value: response.data.dijak?.casco?.casco_bonusz,
                    });

                    if (response.data.dijak.kgfb) {
                        context.commit('setProp', {
                            path: 'valasztottKgfbBiztositoCalcId',
                            value: response.data.dijak.kgfb.selected,
                        });
                        context.commit('setProp', {
                            path: 'valasztottKgfbBiztosito',
                            value: response.data.dijak.kgfb.selected_bizt,
                        });
                        context.commit('setProp', {
                            path: 'hiddenBiztIds',
                            value: response.data.dijak.kgfb.gfb_eltuntet,
                        });
                    }

                    if (response.data.dijak.casco) {
                        context.commit('setProp', {
                            path: 'valasztottCascoBiztositoCalcId',
                            value: response.data.dijak.casco.selected,
                        });
                        context.commit('setProp', {
                            path: 'valasztottCascoBiztosito',
                            value: response.data.dijak.kgfb.selected_bizt,
                        });
                        context.commit('setProp', {
                            path: 'hiddenBiztIds',
                            value: Array.from(
                                new Set(
                                    [
                                        ...context.state.hiddenBiztIds,
                                        ...response.data.dijak.casco.casco_eltuntet,
                                    ],
                                ),
                            ),
                        });
                    }

                    if (!response.data.dijak?.kgfb?.selected) {
                        context.commit('setProp', {
                            path: 'valasztottKgfbBiztositoCalcId',
                            value: null,
                        });
                        context.commit('setProp', {
                            path: 'valasztottKgfbBiztosito',
                            value: null,
                        });
                    }

                    if (!response.data.dijak?.casco?.selected) {
                        context.commit('setProp', {
                            path: 'valasztottCascoBiztositoCalcId',
                            value: null,
                        });
                        context.commit('setProp', {
                            path: 'valasztottCascoBiztosito',
                            value: null,
                        });
                    }
                });
        },

        setUgyfel(context, {
            value,
            path,
            torzsadat = false,
        }) {
            if (value.egyeni_vallalkozo === 'Y') {
                context.commit('setProp', {
                    path: 'tarifaData.mkb_munkahely',
                    value: 11,
                });
            }

            if (value.legfiatalabb_gyerek_szuletesi_datum) {
                context.commit('setProp', {
                    path: 'tarifaData.ajanl_gyerek_szulev',
                    value: parseInt(value.legfiatalabb_gyerek_szuletesi_datum.substring(0, 4), 10),
                });
                context.commit('setProp', {
                    path: 'tarifaData.van_24_evnel_fiatalabb_gyermeke',
                    value: true,
                });
                context.commit('setProp', {
                    path: 'tarifaData.gyerek_sz_ido',
                    value: value.legfiatalabb_gyerek_szuletesi_datum.substring(0, 10).split('-').join(''),
                });
            }

            let ugyfelObj = null;
            if (value.nem === 1 || value.nem === 2) {
                switch (path) {
                    case 'uzembentarto':
                        ugyfelObj = {
                            name: value.nev,
                            sex: value.nem,
                            mobil: typeof value.mobil === 'string'
                                ? `${value.mobil.replace(new RegExp('-', 'g'), '')}`
                                : null,
                            email: value.email,
                            titulus: value.titulus,
                            b_kat_licence_date: value.b_kat_licence_date
                                ? DateFormat.dashedToPlain(value.b_kat_licence_date.split(' ')[0])
                                : null,
                            jogsi_datum: value.b_kat_licence_date
                                ? DateFormat.dashedToPlain(value.b_kat_licence_date.split(' ')[0])
                                : null,
                            has_licence: value.jogositvany_van === 'Y',
                            licence_date: value.jogositvany_kelt
                                ? DateFormat.dashedToPlain(value.jogositvany_kelt.split(' ')[0])
                                : null,
                            birthdate: value.szulido
                                ? DateFormat.dashedToPlain(value.szulido.split(' ')[0])
                                : null,
                            address: {
                                city_code: value.varos,
                                zip: value.irsz,
                            },
                            adoig: value.adoszam,
                            teaor: value.teaor,
                        };

                        if (torzsadat === true) {
                            if (context.state.tarifaData.mkb_munkahely === 11
                            && context.state.uzembentarto.birthdate === value.szulido
                                ? DateFormat.dashedToPlain(value.szulido.split(' ')[0]) : null) {
                                ugyfelObj.adoig = context.state.uzembentarto.adoig;
                            }
                        }

                        if (context.getters.companyId === HUNDEALER && ugyfelObj.b_kat_licence_date) {
                            context.commit('setBKatJogsi', +ugyfelObj.b_kat_licence_date.toString().substring(0, 4));
                        }

                        break;
                    case 'tulajdonos':
                        ugyfelObj = {
                            name: value.name,
                            sex: value.nem,
                            leanynev: value.birthname,
                            szulhely: value.birthplace,
                            anyanev: value.mothername,
                            adoszam: value.personal_taxnumber,
                            okm_tipus: value.document_type,
                            okm_szam: value.document_number,
                            okm_kiallito: value.document_issuer,
                            allampolgarsag: value.allampolgarsag,
                            mobil: typeof value.mobil === 'string'
                                ? `${value.mobil.replace(new RegExp('-', 'g'), '')}`
                                : null,
                            telefon: typeof value.telefon === 'string'
                                ? `${value.telefon.replace(new RegExp('-', 'g'), '')}`
                                : null,
                            email: value.email,
                            titulus: value.titulus,
                            has_licence: value.jogositvany_van === 'Y',
                            licence_date: value.jogositvany_kelt
                                ? DateFormat.dashedToPlain(value.jogositvany_kelt.split(' ')[0])
                                : null,
                            birthdate: value.szulido
                                ? DateFormat.dashedToPlain(value.szulido.split(' ')[0])
                                : null,
                            address: value.address ? value.address : {},
                            levcimegyezik: value.levcimazonos,
                            mail_address: value.mail_address ? value.mail_address : {},
                        };
                        break;
                    // no default
                }
            } else if (value.nem === 3) {
                switch (path) {
                    case 'finanszirozo':
                        ugyfelObj = {
                            cegnev: value.nev,
                            sex: value.nem,
                            mobil: typeof value.mobil === 'string'
                                ? `${value.mobil.replace(new RegExp('-', 'g'), '')}`
                                : null,
                            email: value.email,
                            cegforma: value.cegforma,
                            company_taxnumber: value.adoszam,
                            company_group_taxnumber: value.csoportos_adoszam,
                            teaor: value.teaor,
                            address: {
                                zip: value.address.zip,
                                city_code: value.address.city_code,
                                street_id: value.address.street_id,
                                street_name: value.address.street_name,
                                street_type: value.address.street_type,
                                house_nr_from: value.address.house_nr_from,
                                house_nr_to: value.address.house_nr_to,
                                building: value.address.building,
                                floor: value.address.floor,
                                door: value.address.door,
                                lock_coz_load: true,
                            },
                        };
                        break;
                    case 'uzembentarto':
                        ugyfelObj = {
                            cegnev: value.nev,
                            sex: value.nem,
                            mobil: typeof value.mobil === 'string'
                                ? `${value.mobil.replace(new RegExp('-', 'g'), '')}`
                                : null,
                            email: value.email,
                            cegforma: value.cegforma,
                            company_taxnumber: value.adoszam,
                            company_group_taxnumber: value.csoportos_adoszam,
                            teaor: value.teaor,
                            address: {
                                city_code: value.varos,
                                zip: value.irsz,
                            },
                        };
                        break;
                    case 'tulajdonos':
                        ugyfelObj = {
                            cegnev: value.name,
                            sex: value.nem,
                            mobil: typeof value.mobil === 'string'
                                ? `${value.mobil.replace(new RegExp('-', 'g'), '')}`
                                : null,
                            email: value.email,
                            telefon: typeof value.telefon === 'string'
                                ? `${value.telefon.replace(new RegExp('-', 'g'), '')}`
                                : null,
                            cegforma: value.cegforma,
                            kepviselo_neve: value.kepviselo_neve,
                            kepviselo_beosztasa: value.kepviselo_beosztasa,
                            kepviselo_telefonszama: typeof value.ceg_kepviselo_telefon1 === 'string'
                                ? `${value.ceg_kepviselo_telefon1.replace(new RegExp('-', 'g'), '')}`
                                : null,
                            company_taxnumber: value.adoszam,
                            company_group_taxnumber: value.csoportos_adoszam,
                            teaor: value.teaor,
                            address: {
                                zip: value.address.zip,
                                city_code: value.address.city_code,
                                street_id: value.address.street_id,
                                street_name: value.address.street_name,
                                street_type: value.address.street_type,
                                house_nr_from: value.address.house_nr_from,
                                house_nr_to: value.address.house_nr_to,
                                building: value.address.building,
                                floor: value.address.floor,
                                door: value.address.door,
                                lock_coz_load: true,
                            },
                            levcimegyezik: value.levcimazonos,
                            mail_address: value.mail_address ? {
                                zip: value.mail_address.zip,
                                city_code: value.mail_address.city_code,
                                street_id: value.mail_address.street_id,
                                street_name: value.mail_address.street_name,
                                street_type: value.mail_address.street_type,
                                house_nr_from: value.mail_address.house_nr_from,
                                house_nr_to: value.mail_address.house_nr_to,
                                building: value.mail_address.building,
                                floor: value.mail_address.floor,
                                door: value.mail_address.door,
                                lock_coz_load: true,
                            } : {},
                        };
                        break;
                    // no default
                }
            }

            if (!ugyfelObj) {
                throw new Error('Could not set ugyfelObj in KgfbStore setUgyfel');
            }
            context.commit('setProp', {
                value: ugyfelObj,
                path,
            });
        },

        loadTarifa: async (context, page) => {
            switch (page) {
                case KGFB_ALAPADATOK: {
                    await context.dispatch('loadTarifaAlapAdatok');
                    break;
                }
                case KGFB_DIJAK: {
                    await context.dispatch('loadTarifaDijak');
                    break;
                }
                case KGFB_AJANLATI_ADATOK: {
                    await context.dispatch('loadTarifaAjanlatiAdatok');
                    break;
                }
                case KGFB_NYILATKOZATOK: {
                    await context.dispatch('loadTarifaNyilatkozatok');
                    break;
                }
                case KGFB_AJANLAT: {
                    if (!context.getters.isOvb) {
                        await context.dispatch('loadTarifaAjanlat');
                    } else {
                        await context.dispatch('loadTarifaAjanlatiAdatok');
                    }
                    break;
                }
                // no default
            }
        },
        loadTarifaAlapAdatok: async (context) => {
            context.commit('startLoading');
            await kgfbService.loadTarifa(
                context.state.id,
                context.state.tid,
                context.state.token,
            )
                .then(async (response) => {
                    const bazisnet = parseInt(context.state.loginCeg, 10) === 1
                        || parseInt(context.state.loginCeg, 10) === 462;
                    context.commit('setProp', {
                        path: 'tarifaData',
                        value: response.data.kgfb,
                    });

                    if (
                        typeof response.data.kgfb?.gyerek_sz_ido === 'string'
                        && response.data.kgfb.gyerek_sz_ido.length === 8
                    ) {
                        context.commit('setProp', {
                            path: 'tarifaData.van_24_evnel_fiatalabb_gyermeke',
                            value: true,
                        });
                    }

                    context.dispatch('setAvailablePages', {
                        oldal: response.data.kgfb.max_oldal,
                        isAvailable: bazisnet,
                    });
                    context.commit('setProp', {
                        path: 'gepjarmu',
                        value: response.data.vehicle,
                    });
                    if (
                        response.data.uzembentarto.address === null
                        || response.data.uzembentarto.address.length === 0
                    ) {
                        response.data.uzembentarto.address = {};
                    }

                    context.commit('setProp', {
                        path: 'uzembentarto',
                        value: {address: {}, ...response.data.uzembentarto},
                    });
                    await context.dispatch('loadTarifalasSzerzodoMegbizasEmailAdatok', {
                        ceg: response.data.kgfb?.ceg,
                        ugyfazon: +response.data.uzembentarto?.ugyfazon,
                    });

                    context.commit('setProp', {
                        path: 'tulajdonos',
                        value: {address: {}, ...response.data.tulajdonos},
                    });
                    if (response.data.finanszirozo) {
                        context.commit('setProp', {
                            path: 'finanszirozo',
                            value: response.data.finanszirozo,
                        });
                    }

                    if (response.data.ovb_uzletkoto) {
                        const ovbUzletkoto = response.data.ovb_uzletkoto;
                        context.commit('setOvbUzletkoto', {
                            naturalPersonName: ovbUzletkoto.nev || ovbUzletkoto.naturalPersonName,
                            agentNumber: ovbUzletkoto.ugynokszam || ovbUzletkoto.agentNumber,
                        });
                    }
                    if (response.data.ovb_szakerto) {
                        const ovbSzakerto = response.data.ovb_szakerto;
                        context.commit('setOvbTanacsado', {
                            naturalPersonName: ovbSzakerto.nev || ovbSzakerto.naturalPersonName,
                            agentNumber: ovbSzakerto.ugynokszam || ovbSzakerto.agentNumber,
                        });
                    }
                    if (response.data.ovb_nyilatkozatok) {
                        context.commit('setOvbKezdesNyilatkozatok', response.data.ovb_nyilatkozatok);
                    }

                    const modozatok = response.data.kgfb.modozatok || [];

                    if (response.data.kgfb.ceg === 462) {
                        if (!modozatok.includes(20)) {
                            modozatok.push(20);
                        }
                    }

                    context.commit('setProp', {
                        path: 'modozatok',
                        value: modozatok,
                    });

                    if (context.state.tarifaData.karok == null || context.state.tarifaData.karok.length === 0) {
                        context.commit('resetKarok');
                    }
                    if (context.state.tarifaData.szemlet_vegzo == null
                        || context.state.tarifaData.szemlet_vegzo.length === 0) {
                        context.commit('resetSzemletVegzo');
                    }
                    if (context.state.tarifaData.veszelyes_hasznalati_modok == null) {
                        context.commit('resetHasznalatiModok');
                    }
                    if (context.state.tarifaData.gfb_elozo_szerzodesek_szama == null) {
                        context.commit('resetUzemeltetettGepjDb');
                    }
                    context.commit('stopLoading');
                });
        },
        loadTarifaDijak: async (context) => {
            context.commit('setProp', {
                path: 'dijak',
                value: [],
            });
            context.commit('setProp', {
                path: 'valasztottKgfbBiztosito',
                value: null,
            });
            context.commit('setProp', {
                path: 'kgfb_calculation_id',
                value: null,
            });

            context.commit('startLoading');
            await kgfbService.loadTarifa(context.state.id, context.state.tid)
                .then(async (response) => {
                    const bazisnet = parseInt(context.state.loginCeg, 10) === 1
                        || parseInt(context.state.loginCeg, 10) === 462;

                    context.commit('setProp', {
                        path: 'tarifaData',
                        value: response.data.kgfb,
                    });
                    context.dispatch('setAvailablePages', {
                        oldal: response.data.kgfb.max_oldal,
                        isAvailable: bazisnet,
                    });
                    context.commit('setProp', {
                        path: 'gepjarmu',
                        value: response.data.vehicle,
                    });
                    context.commit('setProp', {
                        path: 'uzembentarto',
                        value: response.data.uzembentarto,
                    });
                    await context.dispatch('loadTarifalasSzerzodoMegbizasEmailAdatok', {
                        ceg: response.data.kgfb?.ceg,
                        ugyfazon: +response.data.uzembentarto?.ugyfazon,
                    });
                    context.commit('setProp', {
                        path: 'tulajdonos',
                        value: response.data.tulajdonos,
                    });
                    if (response.data.finanszirozo) {
                        context.commit('setProp', {
                            path: 'finanszirozo',
                            value: response.data.finanszirozo,
                        });
                    }
                    context.commit('setProp', {
                        path: 'modozatok',
                        value: response.data.kgfb.modozatok,
                    });

                    if (response.data.kgfb.dijsorrend) {
                        context.commit('setProp', {
                            path: 'rendezettseg',
                            value: response.data.kgfb.dijsorrend,
                        });
                    } else {
                        const defaultFeeOrder = response.data.kgfb.modozatok.includes(KGFB)
                            ? 3 // 'KGFB ár szerint növekvő'
                            : 5; // 'CASCO ár szerint növekvő
                        context.commit('setProp', {path: 'rendezettseg', value: defaultFeeOrder});
                        kgfbService.saveRendezettseg(context.state.id, context.state.rendezettseg);
                    }

                    const kedvezmenyekbiztosito = {};
                    const kedvezmenyekalaptabla = {};

                    const {kedvezmenyek} = response.data.kgfb;
                    Object.keys(kedvezmenyek)
                        .forEach((biztositoid) => {
                            kedvezmenyekbiztosito[biztositoid] = kedvezmenyek[biztositoid].biztositomezo;
                            kedvezmenyekalaptabla[biztositoid] = kedvezmenyek[biztositoid].alaptabla;
                        });

                    context.commit('setProp', {
                        path: 'kedvezmenyekbiztosito',
                        value: {...kedvezmenyekbiztosito},
                    });
                    context.commit('setProp', {
                        path: 'kedvezmenyekalaptabla',
                        value: {...kedvezmenyekalaptabla},
                    });
                });

            context.commit('startLoading');
            await kgfbService.loadDijak(
                context.state.tid,
                context.state.id,
                context.state.tarifaData.tarifa_id,
            )
                .then((response) => {
                    const kedvezmenyek = KgfbTarifa.getProcessedKgfbKedvezmenyekAdditions(response.data.dijak);
                    context.dispatch('setKedvezmenyekAdditions', kedvezmenyek);

                    if (response.data.dijak.kgfb) {
                        context.commit(
                            'setFedezetlensegiDij',
                            KgfbTarifa.getFedezetlensegiDij(response.data.dijak.kgfb.tarifaDijak),
                        );
                    }

                    const dij = KgfbTarifa.getProcessedDijak(response.data.dijak, context);
                    context.commit('setProp', {
                        path: 'dijak',
                        value: dij,
                    });

                    if (response.data.dijak?.assistance) {
                        KgfbTarifa.setAssistance(response.data.dijak.assistance, context);
                    }

                    context.dispatch('orderFees');

                    context.commit('setProp', {
                        path: 'casco_bonusz',
                        value: response.data.dijak?.casco?.casco_bonusz,
                    });

                    context.commit('setProp', {
                        path: 'dasdij',
                        value: response.data.dijak?.kgfb?.dasdij
                            ? response.data.dijak?.kgfb?.dasdij
                            : response.data.dijak?.casco?.dasdij,
                    });

                    if (response.data.dijak.kgfb) {
                        context.commit('setProp', {
                            path: 'valasztottKgfbBiztositoCalcId',
                            value: response.data.dijak.kgfb.selected,
                        });
                        context.commit('setProp', {
                            path: 'valasztottKgfbBiztosito',
                            value: response.data.dijak.kgfb.selected_bizt,
                        });

                        if (!response.data.dijak.kgfb.selected) {
                            context.commit('setProp', {
                                path: 'valasztottKgfbBiztosito',
                                value: null,
                            });

                            context.commit('setProp', {
                                path: 'kgfb_calculation_id',
                                value: null,
                            });
                        }

                        context.commit('setProp', {
                            path: 'hiddenBiztIds',
                            value: response.data.dijak.kgfb.gfb_eltuntet,
                        });
                    }

                    if (response.data.dijak.casco) {
                        context.commit('setProp', {
                            path: 'valasztottCascoBiztositoCalcId',
                            value: response.data.dijak.casco.selected,
                        });
                        context.commit('setProp', {
                            path: 'valasztottCascoBiztosito',
                            value: response.data.dijak.casco.selected_bizt,
                        });

                        if (!response.data.dijak.casco.selected) {
                            context.commit('setProp', {
                                path: 'valasztottCascoBiztosito',
                                value: null,
                            });

                            context.commit('setProp', {
                                path: 'casco_calculation_id',
                                value: null,
                            });
                        }

                        context.commit('setProp', {
                            path: 'hiddenBiztIds',
                            value: Array.from(
                                new Set(
                                    [
                                        ...context.state.hiddenBiztIds,
                                        ...response.data.dijak.casco.casco_eltuntet,
                                    ],
                                ),
                            ),
                        });
                    }

                    if (context.state.dijak.length === 0 && context.getters.kockakezdetJovobeli) {
                        kgfbService.calculate(
                            context.state.tid,
                            context.state.id,
                            {
                                ...KgfbTarifa.getRecalculateDataByBiztIds(
                                    MINDEN_BIZTOSITO,
                                    true,
                                    context.state.modozatok,
                                    false,
                                    context,
                                    true,
                                ),
                            },
                        )
                            .then((calculateResponse) => {
                                const kedv = KgfbTarifa.getProcessedKgfbKedvezmenyekAdditions(
                                    calculateResponse.data.dijak,
                                );
                                context.dispatch('setKedvezmenyekAdditions', kedv);

                                const dijak = KgfbTarifa.getProcessedDijak(calculateResponse.data.dijak, context);

                                context.commit('setProp', {
                                    path: 'dijak',
                                    value: dijak,
                                });

                                if (calculateResponse.data.dijak?.assistance) {
                                    KgfbTarifa.setAssistance(calculateResponse.data.dijak.assistance, context);
                                }

                                context.dispatch('orderFees');

                                context.commit('setProp', {
                                    path: 'casco_bonusz',
                                    value: response.data.dijak?.casco?.casco_bonusz,
                                });

                                context.commit('setProp', {
                                    path: 'dasdij',
                                    value: calculateResponse.data.dijak?.kgfb?.dasdij
                                        ? calculateResponse.data.dijak?.kgfb?.dasdij
                                        : calculateResponse.data.dijak?.casco?.dasdij,
                                });
                                let calculationsCount = 0;
                                if (typeof calculateResponse.data.dijak?.kgfb?.calculationsCount === 'number') {
                                    calculationsCount += calculateResponse.data.dijak?.kgfb?.calculationsCount;
                                }
                                if (typeof calculateResponse.data.dijak?.casco?.calculationsCount === 'number') {
                                    calculationsCount += calculateResponse.data.dijak?.casco?.calculationsCount;
                                }
                                context.commit('setProp', {
                                    path: 'tarifaData.calculationsCount',
                                    calculationsCount,
                                });
                                const oldal = 1;
                                context.commit('setProp', {
                                    path: 'tarifaData.max_oldal',
                                    value: oldal,
                                });

                                const bazisnet = parseInt(context.state.loginCeg, 10) === 1
                                    || parseInt(context.state.loginCeg, 10) === 462;

                                if (calculateResponse.data.dijak.kgfb) {
                                    context.commit(
                                        'setFedezetlensegiDij',
                                        KgfbTarifa.getFedezetlensegiDij(
                                            calculateResponse.data.dijak.kgfb.tarifaDijak,
                                        ),
                                    );
                                    context.commit('setProp', {
                                        path: 'indexDij',
                                        value: calculateResponse.data.dijak.kgfb.indexdij,
                                    });
                                }
                                if (response.data.dijak.kgfb) {
                                    context.commit('setProp', {
                                        path: 'valasztottKgfbBiztositoCalcId',
                                        value: response.data.dijak.kgfb.selected,
                                    });

                                    if (!response.data.dijak.kgfb.selected) {
                                        context.commit('setProp', {
                                            path: 'valasztottKgfbBiztosito',
                                            value: null,
                                        });

                                        context.commit('setProp', {
                                            path: 'kgfb_calculation_id',
                                            value: null,
                                        });
                                    }

                                    context.commit('setProp', {
                                        path: 'hiddenBiztIds',
                                        value: response.data.dijak.kgfb.gfb_eltuntet,
                                    });
                                }

                                if (response.data.dijak.casco) {
                                    context.commit('setProp', {
                                        path: 'valasztottCascoBiztositoCalcId',
                                        value: response.data.dijak.casco.selected,
                                    });

                                    if (!response.data.dijak.casco.selected) {
                                        context.commit('setProp', {
                                            path: 'valasztottCascoBiztosito',
                                            value: null,
                                        });

                                        context.commit('setProp', {
                                            path: 'casco_calculation_id',
                                            value: null,
                                        });
                                    }

                                    context.commit('setProp', {
                                        path: 'hiddenBiztIds',
                                        value: Array.from(
                                            new Set(
                                                [
                                                    ...context.state.hiddenBiztIds,
                                                    ...response.data.dijak.casco.casco_eltuntet,
                                                ],
                                            ),
                                        ),
                                    });
                                }

                                context.dispatch('setAvailablePages', {
                                    oldal,
                                    isAvailable: bazisnet,
                                });
                                context.commit('stopLoading');
                            });
                    } else {
                        if (response.data.dijak.kgfb) {
                            context.commit('setProp', {
                                path: 'indexDij',
                                value: response.data.dijak.kgfb.indexdij,
                            });
                            context.commit(
                                'setFedezetlensegiDij',
                                KgfbTarifa.getFedezetlensegiDij(response.data.dijak.kgfb.tarifaDijak),
                            );
                        }
                        context.commit('stopLoading');
                    }
                });
        },
        loadTarifaAjanlatiAdatok: async (context) => {
            context.commit('startLoading');

            await kgfbService.loadOffer(context.state.id, context.state.tid)
                .then(async (response) => {
                    const bazisnet = parseInt(context.state.loginCeg, 10) === 1
                        || parseInt(context.state.loginCeg, 10) === 462;

                    if (
                        Array.isArray(response.data?.kgfb?.elozo_karok)
                        && response.data.kgfb.elozo_karok.length === 0
                    ) {
                        response.data.kgfb.elozo_karok = {};
                    }

                    context.commit('setProp', {
                        path: 'tarifaData',
                        value: response.data.kgfb,
                    });

                    if (response.data.kgfb.finanszirozas.finansz_tipus === null && response.data.kgfb.casco_biztosito === 8) {
                        context.commit('setProp', {
                            path: 'tarifaData.finanszirozas.finansz_tipus',
                            value: 'T',
                        });
                    }

                    context.dispatch('setAvailablePages', {
                        oldal: response.data.kgfb.max_oldal,
                        isAvailable: bazisnet,
                    });

                    context.commit('setProp', {
                        path: 'gepjarmu',
                        value: response.data.vehicle,
                    });

                    context.commit('setProp', {
                        path: 'modozatok',
                        value: response.data.kgfb.modozatok,
                    });

                    context.commit('setProp', {
                        path: 'selected',
                        value: response.data.selected,
                    });

                    if (
                        response.data.uzembentarto
                        && response.data.uzembentarto.bankszamlaszam
                        && typeof response.data.uzembentarto.bankszamlaszam === 'string'
                        && /^[0-9]{24}$/.test(response.data.uzembentarto.bankszamlaszam)
                    ) {
                        response.data.uzembentarto.bankszamlaszam = mask(
                            response.data.uzembentarto.bankszamlaszam,
                            '########-########-########',
                        ).nice;
                    }

                    context.commit('setProp', {
                        path: 'uzembentarto',
                        value: response.data.uzembentarto,
                    });

                    await context.dispatch('loadTarifalasSzerzodoMegbizasEmailAdatok', {
                        ceg: response.data.kgfb?.ceg,
                        ugyfazon: +response.data.uzembentarto?.ugyfazon,
                    });

                    context.commit('setProp', {
                        path: 'tulajdonos',
                        value: response.data.tulajdonos,
                    });

                    if (response.data.finanszirozo) {
                        if (
                            (
                                Array.isArray(response.data?.finanszirozo?.address)
                                && response.data.finanszirozo.address.length === 0
                            ) || !response.data?.finanszirozo?.address
                        ) {
                            response.data.finanszirozo.address = {};
                        }
                        context.commit('setProp', {
                            path: 'finanszirozo',
                            value: response.data.finanszirozo,
                        });
                    }

                    if (response.data.selected.kgfb) {
                        context.commit('setProp', {
                            path: 'valasztottKgfbBiztosito',
                            value: response.data.selected.kgfb,
                        });
                    }

                    if (response.data.selected.casco) {
                        context.commit('setProp', {
                            path: 'valasztottCascoBiztosito',
                            value: response.data.selected.casco,
                        });
                    }

                    if (response.data.selected.assistencia) {
                        context.commit('setProp', {
                            path: 'valasztottAssistanceDijAdatok',
                            value: response.data.selected.assistencia,
                        });
                    }

                    const kedvezmenyek = KgfbTarifa.getProcessedKgfbKedvezmenyekAdditions({
                        kgfb: {
                            tarifaDijak: [
                                {
                                    biztositoid: response.data.selected.kgfb,
                                    tarifa_properties: {
                                        discounts: response.data.selected.discount,
                                        additionals: response.data.selected.additionals,
                                    },
                                },
                            ],
                        },
                        casco: {
                            tarifaDijak: [
                                {
                                    biztositoid: response.data.selected.casco,
                                    tarifa_properties: {
                                        discounts: response.data.selected.casco_discount,
                                        additionals: response.data.selected.casco_additionals,
                                    },
                                },
                            ],
                        },
                    });
                    context.commit('setSzemle', response.data?.selected?.szemle);
                    context.dispatch('setKedvezmenyekAdditions', kedvezmenyek);
                    context.commit('stopLoading');

                    if (
                        context.state.tarifaData.groupama == null
                        || context.state.tarifaData.groupama.length === 0
                    ) {
                        context.commit('resetGroupama');
                    }
                    if (
                        context.state.tarifaData.uniqa == null
                        || context.state.tarifaData.uniqa.length === 0
                    ) {
                        context.commit('resetUniqa');
                    }

                    if (context.state.tarifaData.allapotlap == null
                        || context.state.tarifaData.allapotlap.length === 0) {
                        context.commit('resetAllapotLap');
                    }

                    if (context.state.tarifaData.evenkenti_karok == null
                        || context.state.tarifaData.evenkenti_karok.length === 0) {
                        context.commit('resetEvenkentiKarok');
                    }

                    if (context.state.tarifaData.elozo_karok == null) {
                        context.commit('resetElozoKarok');
                    }
                });
        },
        loadTarifaNyilatkozatok: async (context) => {
            context.commit('startLoading');
            nyilatkozatokService.getKgfbNyilatkozatok(context.state.id)
                .then((response) => {
                    context.commit('setProp', {
                        path: 'kgfbNyilatkozatok',
                        value: response.data,
                    });

                    const bazisnet = parseInt(context.state.loginCeg, 10) === 1
                        || parseInt(context.state.loginCeg, 10) === 462;

                    context.dispatch('setAvailablePages', {
                        oldal: response.data.max_oldal,
                        isAvailable: bazisnet,
                    });

                    context.commit('setProp', {
                        path: 'tarifaData',
                        value: response.data.tarifaData,
                    });

                    context.commit('setProp', {
                        path: 'modozatok',
                        value: response.data.modozatok,
                    });

                    context.commit('setProp', {
                        path: 'gepjarmu',
                        value: response.data.gepjarmu,
                    });

                    context.commit('setProp', {
                        path: 'uzembentarto',
                        value: response.data.uzembentarto,
                    });

                    const kgfb = {
                        kotelezo: {},
                        nem_kotelezo: {},
                    };
                    const casco = {
                        kotelezo: {},
                        nem_kotelezo: {},
                    };
                    const assistance = {
                        kotelezo: {},
                        nem_kotelezo: {},
                    };
                    const ceges = {};

                    if (response.data.kgfb.kotelezo) {
                        response.data.kgfb.kotelezo.forEach((nyilatkozat) => {
                            kgfb.kotelezo[nyilatkozat.id] = (nyilatkozat.value !== null
                                || typeof nyilatkozat.value !== 'undefined')
                                ? nyilatkozat.value
                                : nyilatkozat.default;
                        });
                    }
                    if (response.data.casco.kotelezo) {
                        response.data.casco.kotelezo.forEach((nyilatkozat) => {
                            casco.kotelezo[nyilatkozat.id] = (nyilatkozat.value !== null
                                || typeof nyilatkozat.value !== 'undefined')
                                ? nyilatkozat.value
                                : nyilatkozat.default;
                        });
                    }
                    if (response.data.assistance.kotelezo) {
                        response.data.assistance.kotelezo.forEach((nyilatkozat) => {
                            assistance.kotelezo[nyilatkozat.id] = (nyilatkozat.value !== null
                                || typeof nyilatkozat.value !== 'undefined')
                                ? nyilatkozat.value
                                : nyilatkozat.default;
                        });
                    }

                    if (response.data.kgfb.nem_kotelezo) {
                        response.data.kgfb.nem_kotelezo.forEach((nyilatkozat) => {
                            kgfb.nem_kotelezo[nyilatkozat.id] = (nyilatkozat.value !== null
                                || typeof nyilatkozat.value !== 'undefined')
                                ? nyilatkozat.value
                                : nyilatkozat.default;
                        });
                    }
                    if (response.data.casco.nem_kotelezo) {
                        response.data.casco.nem_kotelezo.forEach((nyilatkozat) => {
                            casco.nem_kotelezo[nyilatkozat.id] = (nyilatkozat.value !== null
                                || typeof nyilatkozat.value !== 'undefined')
                                ? nyilatkozat.value
                                : nyilatkozat.default;
                        });
                    }
                    if (response.data.assistance.nem_kotelezo) {
                        response.data.assistance.nem_kotelezo.forEach((nyilatkozat) => {
                            assistance.nem_kotelezo[nyilatkozat.id] = (nyilatkozat.value !== null
                                || typeof nyilatkozat.value !== 'undefined')
                                ? nyilatkozat.value
                                : nyilatkozat.default;
                        });
                    }

                    if (response.data.ceges) {
                        response.data.ceges.forEach((nyilatkozat) => {
                            ceges[nyilatkozat.id] = (nyilatkozat.value !== null
                                || typeof nyilatkozat.value !== 'undefined')
                                ? nyilatkozat.value
                                : nyilatkozat.default;
                        });
                    }

                    const nyilatkozatok = {
                        kgfb,
                        casco,
                        assistance,
                        ceges,
                    };
                    context.commit('setProp', {
                        path: 'nyilatkozatok',
                        value: nyilatkozatok,
                    });

                    context.commit('stopLoading');
                });
        },
        loadTarifaAjanlat: async (context) => {
            context.commit('startLoading');
            kgfbService.getOfferCheckData(context.state.id)
                .then((response) => {
                    context.dispatch('setAvailablePages', {
                        oldal: response.data.max_oldal,
                    });
                    context.commit('setProp', {
                        path: 'modozatok',
                        value: response.data.modozatok,
                    });
                    context.commit('setProp', {
                        path: 'gepjarmu',
                        value: response.data.vehicle,
                    });
                    context.commit('setProp', {
                        path: 'uzembentarto',
                        value: response.data.uzembentarto,
                    });
                    context.commit('setProp', {
                        path: 'tulajdonos',
                        value: response.data.tulajdonos,
                    });
                    context.commit('setProp', {
                        path: 'finanszirozo',
                        value: response.data.finanszirozo,
                    });
                    context.commit('setProp', {
                        path: 'selected',
                        value: {
                            kgfb: response.data.kgfb,
                            casco: response.data.casco,
                            assistance: response.data.assistance,
                        },
                    });
                    context.commit('setProp', {
                        path: 'tarifaData',
                        value: response.data.tarifaData,
                    });
                    context.commit('setProp', {
                        path: 'nyilatkozatPdf',
                        value: response.data.nyilatkozat,
                    });
                    context.commit('setProp', {
                        path: 'offerDeclarations',
                        value: response.data.tarifaData.ajanlat_folyamat_nyilatkozatok
                            ? response.data.tarifaData.ajanlat_folyamat_nyilatkozatok : {},
                    });
                })
                .finally(() => {
                    context.commit('stopLoading');
                });
        },

        saveKieg(context, {
            biztositoid,
            calculationId,
        }) {
            return kgfbService.saveKieg(
                context.state.id,
                context.state.tid,
                {
                    tarifaData: {
                        id: context.state.id,
                        tarifa_id: context.state.tarifaData.tarifa_id,
                        ajanl_fizmod_type: context.state.tarifaData.ajanl_fizmod_type,
                        ajanl_fizutem_type: context.state.tarifaData.ajanl_fizutem_type,
                        calculation_id: calculationId,
                    },
                    additions: {
                        [biztositoid]: context.state.additions[biztositoid],
                    },
                },
            );
        },

        recalc: (context, {
            biztositoid,
            modozat,
        }) => {
            context.commit('setRecalculationInProgress', true);
            if (biztositoid === context.getters.valasztottKgfbBiztosito) context.dispatch('removeKgfbSelection');
            if (biztositoid === context.getters.valasztottCascoBiztosito) context.dispatch('removeCascoSelection');
            const calcObj = KgfbTarifa.getRecalculateDataByBiztIds([biztositoid], false, modozat, false, context);
            return kgfbService
                .calculate(context.state.tid, context.state.id, calcObj)
                .then((response) => {
                    KgfbTarifa.calculationResponseHandler(response, context);

                    let i = 0;
                    for (i; i < context.state.dijak.length; i += 1) {
                        if (context.state.dijak[i].biztositoid === biztositoid) {
                            break;
                        }
                    }

                    let vanDij = false;
                    if (modozat === KGFB) {
                        vanDij = parseInt(context.state.dijak[i].kgfb.yearly_fee, 10) > 0;
                    } else {
                        vanDij = parseInt(context.state.dijak[i].casco.yearly_fee, 10) > 0;
                    }
                    context.commit(
                        'setRecalculationInProgress',
                        false,
                    );
                    return Promise.resolve(vanDij);
                });
        },
        saveTarifa: (context, payload) => {
            if (
                (
                    context.state.gepjarmu.kmallas === '0'
                    || context.state.gepjarmu.kmallas === 0
                )
                && context.state.tarifaData.ajanl_megkotok_type === 2
            ) {
                context.state.gepjarmu.kmallas = 1;
                context.state.tarifaData.mapfre_assistencia_km = true;
            }
            context.commit('formatNumbers');
            const data = getTarifaDataForSave(context.state);
            data.modozatok = context.state.modozatok;

            return kgfbService.save(
                context.state.id,
                context.state.tid,
                {
                    tarifaData: data,
                    vehicle: context.state.gepjarmu,
                    uzembentarto: context.state.uzembentarto,
                    tulajdonos: context.state.tulajdonos,
                    finanszirozo: context.state.finanszirozo,
                    plainSave: payload.plainSave,
                    firstpage_save_hash: context.state.token,
                    first_page_token: context.state.token,
                    nyilatkozat_id: context.state.companyDeclarations
                        .filter((decl) => decl.place === MENTES_NYILATKOZAT)[0]?.id,
                    ...(context.getters.companyId === 462 && {
                        ovb_callback_hash: context.getters.ovbCallbackHash,
                        ovb_nyilatkozatok: context.getters.getOvbKezdesNyilatkozatok?.map(({ compulsory, position, ...d }) => d),
                        ...(context.getters.getOvbTanacsado != null && {
                            ovb_szakerto: {
                                ugynokszam: context.getters.getOvbTanacsado.agentNumber,
                                nev: context.getters.getOvbTanacsado.naturalPersonName,
                            }
                        }),
                        ...(context.getters.getOvbUzletkoto != null && {
                            ovb_uzletkoto: {
                                ugynokszam: context.getters.getOvbUzletkoto.agentNumber,
                                nev: context.getters.getOvbUzletkoto.naturalPersonName,
                                email: context.getters.getOvbUzletkoto.emailAddress,
                                mobil: context.getters.getOvbUzletkoto.mobilePhoneNumber,
                            }
                        })
                    })
                }, payload.plainSave,
            )
                .then((response) => {
                    if (response?.data?.data?.tarifa_id) {
                        context.commit('setTarifaId', response.data.data.tarifa_id);
                        context.commit('setId', response.data.data.id);
                        window.history.pushState(
                            {},
                            '',
                            `${window.location}/${response.data.data.id}/${response.data.data.id}`,
                        );
                    } else if (context.state.companyId === 462) {
                        context.commit('setToken', response.data.data.token);
                        const searchParams = new URLSearchParams(window.location.search);
                        searchParams.set('token', response.data.data.token);
                        window.location.search = searchParams.toString();
                    } else {
                        context.commit('setToken', response.data.data.token);
                        const {hash} = window.location;
                        const [path, existingQuery] = hash.slice(1).split('?');
                        const params = new URLSearchParams(existingQuery);
                        params.set('token', response.data.data.token);
                        window.location.hash = `${path}?${params.toString()}`;
                    }
                });
        },
        saveDijtabla: (context, payload) => {
            const kellGfb = context.state.modozatok.includes(KGFB);
            const kellCasco = context.state.modozatok.includes(CASCO);
            const kellAssistance = context.state.modozatok.includes(MAPFREA);
            context.commit('formatNumbers');

            if (payload.plainSave) {
                const data = getTarifaDataForSave(context.state);
                return kgfbService.save(context.state.id, context.state.tid, {
                    tarifaData: data,
                    vehicle: context.state.gepjarmu,
                    uzembentarto: context.state.uzembentarto,
                    tulajdonos: context.state.tulajdonos,
                    finanszirozo: context.state.finanszirozo,
                    plainSave: payload.plainSave,
                    firstpage_save_hash: context.state.token,
                    nyilatkozatId: context.state.nyilatkozatId,
                }, payload.plainSave);
            }
            return kgfbService.saveDijak(context.state.id, context.state.tid, {
                id: context.state.id,
                tarifa_id: context.state.tarifaData.tarifa_id,
                biztosito_id: (Number(context.state.valasztottKgfbBiztosito) > 0)
                && kellGfb
                    ? context.state.valasztottKgfbBiztosito
                    : null,
                casco_biztosito_id: (Number(context.state.valasztottCascoBiztosito) > 0)
                && kellCasco
                    ? context.state.valasztottCascoBiztosito
                    : null,
                calculation_id: (Number(context.state.kgfb_calculation_id) > 0)
                && kellGfb
                    ? context.state.kgfb_calculation_id
                    : null,
                casco_calculation_id: (Number(context.state.casco_calculation_id) > 0)
                && kellCasco
                    ? context.state.casco_calculation_id
                    : null,
                assistance: context.getters.valasztottAssistanceCsomag && kellAssistance
                    ? context.getters.valasztottAssistanceCsomag
                    : null,
            });
        },
        saveAjanlat: (context, payload) => {
            if (
                (
                    context.state.gepjarmu.kmallas === '0'
                    || context.state.gepjarmu.kmallas === 0
                )
                && context.state.tarifaData.ajanl_megkotok_type === 2
            ) {
                context.state.gepjarmu.kmallas = 1;
                context.state.tarifaData.mapfre_assistencia_km = true;
            }
            context.commit('formatNumbers');
            const data = getTarifaDataForSave(context.state);
            return kgfbService.saveOffer(context.state.id, context.state.tid, {
                tarifaData: data,
                vehicle: context.state.gepjarmu,
                uzembentarto: context.state.uzembentarto,
                tulajdonos: context.state.tulajdonos,
                finanszirozo: context.state.finanszirozo,
                plainSave: payload.plainSave,
                nyilatkozat_id: context.state.companyDeclarations
                    .filter((decl) => decl.place === MENTES_NYILATKOZAT)[0]?.id,
            });
        },
        saveNyilatkozat: (context) => nyilatkozatokService.saveKgfbNyilatkozat(
            context.state.id,
            {
                ...context.state.nyilatkozatok,
                kotelezo: {},
                nem_kotelezo: {},
            },
        ),
        setDas: (context) => kgfbService.setDas(
            context.state.id,
            context.state.tarifaData.tarifa_id,
            context.state.tarifaData.das_jogvedelem,
        ),
        setMapfre: (context) => kgfbService.setMapfre(
            context.state.id,
            context.state.tarifaData.tarifa_id,
            context.state.tarifaData.mapfre_asszisztencia,
        ),
        getBroker: (context) => BrokerService.getBrokerData()
            .then(
                (broker) => {
                    context.commit('setBroker', broker.data);
                },
            ),
        getCompanyDeclarations: (context) => {
            // eslint-disable-next-line no-unused-vars
            const ceg = context.getters.companyId;
            const modozat = 2;

            return nyilatkozatokService.getCompanyDeclarations(
                ceg,
                modozat,
            )
                .then(
                    (declarations) => {
                        context.commit('setCompanyDeclarations', declarations.data);
                    },
                );
        },
        loadTarifalasSzerzodoMegbizasEmailAdatok(context, { ceg, ugyfazon }) {
            if (![6, 462, 518, 564].includes(+ceg) && +ugyfazon > 0) {
                return UgyfeltorzsService.getClientMasterData(ugyfazon, 'megbizas_megerositett_email')
                    .then((res) => {
                        context.commit('setProp', {
                            path: 'tarifalasSzerzodoMegbizasEmailAdatok',
                            value: res.data,
                        });
                    });
            }
            context.commit('setProp', {
                path: 'tarifalasSzerzodoMegbizasEmailAdatok',
                value: null,
            });
            return new Promise((resolve) => resolve());
        },
        getDefaultData: (context) => {
            context.commit('setProp', {path: 'tarifaData.ajanl_megkotok_type', value: null});
            context.commit('setProp', {path: 'tarifaData.belepnyil', value: null});
            context.commit('startLoading');
            return kgfbService.getDefaultData()
                .then((response) => {
                    if (response.data.kgfb) {
                        context.commit('setProp', {path: 'tarifaData', value: response.data.kgfb});
                        context.commit('setProp', {path: 'modozatok', value: response.data.kgfb.modozatok});
                    }
                    if (response.data.vehicle) {
                        context.commit('setProp', {path: 'gepjarmu', value: response.data.vehicle});
                    }
                })
                .finally(() => {
                    context.commit('stopLoading');
                });
        },
        getDataByToken: (context, token) => {
            context.commit('setProp', {path: 'tarifaData.tarifa_external_hash', value: token});
            context.commit('startLoading');
            kgfbService.getDataByToken(token)
                .then(async (response) => {
                    if (response.data.uzembentarto) {
                        let {uzembentarto} = response.data;
                        if (uzembentarto.nem === 3) {
                            try {
                                const partnerDataRes = await partnerDataByTaxNumber.loadCompanyPartnerDataByTaxNumber(
                                    uzembentarto.adoszam
                                );
                                uzembentarto = {
                                    ...uzembentarto,
                                    nev: partnerDataRes.data.name,
                                    cegforma: partnerDataRes.data.company_type,
                                };
                            } catch (err) {
                                notify.failureNotify(
                                    'Adószám alapú cég név betöltés nem sikerült',
                                    'Betöltés sikertelen'
                                );
                            }
                        }
                        context.dispatch('setUgyfel', {
                            path: 'uzembentarto',
                            value: uzembentarto,
                        });
                    }
                    if (response.data.gepjarmu) {
                        context.commit('setProp', {
                            path: 'gepjarmu',
                            value: response.data.gepjarmu
                        });
                    }
                })
                .finally(() => {
                    context.commit('stopLoading');
                });
        },
        removeKgfbSelection(context) {
            context.commit('setProp', {
                path: 'valasztottKgfbBiztosito',
                value: null,
            });
            context.commit('setProp', {
                path: 'valasztottKgfbBiztositoCalcId',
                value: null,
            });
            context.commit('setProp', {
                path: 'kgfb_calculation_id',
                value: null,
            });
        },
        removeCascoSelection(context) {
            context.commit('setProp', {
                path: 'valasztottCascoBiztosito',
                value: null,
            });
            context.commit('setProp', {
                path: 'valasztottCascoBiztositoCalcId',
                value: null,
            });
            context.commit('setProp', {
                path: 'casco_calculation_id',
                value: null,
            });
        },
    },
};
/* eslint-enable no-param-reassign */
